/**
 * El botón «Descargar manual de uso en PDF» de la cabecera · 29-09-2026
 *
 * Abre el manual de uso en otra pestaña. Hay dos, y **no se sirven igual a
 * propósito**:
 *
 * - **El de los clubes** es un fichero estático del panel
 *   (`public/manuales/manual-clubes.pdf`). Que alguien lo descargue sin sesión no
 *   es un problema: es el mismo manual que el club reenvía a sus familias.
 * - **El del back office** lo sirve la API (`GET /v1/admin/manual`) solo al
 *   personal de Kiap. Explica cómo operamos por dentro, y todo lo que está en
 *   `public/` se descarga sin sesión. Por eso va por `abrirDocumento`, con el token
 *   de la sesión, como un recibo.
 *
 * Los dos PDF los genera `manuales/generar-pdf.ts`, que deja cada uno en su sitio.
 */
import { useState } from 'react';
import { opcionesDeSesion } from '@/shared/api/client';
import { abrirDocumento } from '@/shared/api/descargas';
import { Icono } from '@/shared/ui/Icono';

const DEL_CLUB = '/manuales/manual-clubes.pdf';

export function BotonDelManual({
  de,
  variante = 'cabecera',
}: {
  de: 'club' | 'backoffice';
  /** `menu`: una línea del menú de cuenta del móvil, con su icono. */
  variante?: 'cabecera' | 'menu';
}) {
  const [abriendo, setAbriendo] = useState(false);
  const [fallo, setFallo] = useState<string | null>(null);

  const abrir = async () => {
    setFallo(null);
    if (de === 'club') {
      window.open(DEL_CLUB, '_blank', 'noopener');
      return;
    }
    setAbriendo(true);
    const problema = await abrirDocumento('/v1/admin/manual', opcionesDeSesion);
    setAbriendo(false);
    if (problema) setFallo(problema.detail ?? problema.title);
  };

  return (
    <>
      {/*
        En el móvil, «Manual»: el texto entero no cabía en la fila de la cabecera
        y la partía en dos (12-10-2026). El nombre completo sigue en `title` y
        para el lector de pantalla.
      */}
      <button
        type="button"
        className={variante === 'menu' ? 'menu-item' : 'btn-plano'}
        role={variante === 'menu' ? 'menuitem' : undefined}
        onClick={() => void abrir()}
        disabled={abriendo}
        title="Descargar manual de uso en PDF"
        aria-label="Descargar manual de uso en PDF"
      >
        {variante === 'menu' && <Icono nombre="manual" />}
        {abriendo ? (
          'Abriendo…'
        ) : variante === 'menu' ? (
          'Manual de uso (PDF)'
        ) : (
          <>
            <span className="solo-ancho">Descargar manual de uso en PDF</span>
            <span className="solo-movil">Manual</span>
          </>
        )}
      </button>
      {fallo ? (
        <span className="tenue" role="alert">
          {fallo}
        </span>
      ) : null}
    </>
  );
}
